<app-main-layout>
  <app-tickets-page></app-tickets-page>
</app-main-layout>
